<h1>{{count}}</h1>
<div>
  Login
</div>
<button (click)="this.clickHandler()">click</button>
